import React from 'react'
import './App.css'
import Content from './components/Content'

const App : React.FC = () => {
  return (
    <div className="App">
      <Content/>
    </div>
  )
}

export default App
